import { useEffect } from 'react';

import PropTypes from 'prop-types';

import { UNIT_STATUS_REASON } from '#client/constants/transfer';
import useDepositContext from '#client/hooks/useDepositContext';
import useFormStep from '#client/hooks/useFormStep';

import DepositLoading from './DepositLoading';
import ErrorForm from './ErrorForm';
import SuccessForm from './SuccessForm';

export default function ConfirmationForm({ handleClose, handleClosePreviousModal }) {
  const { data, setData } = useFormStep();

  const { depositData, depositError, loading } = useDepositContext();

  // Hide modal title when api is loading
  useEffect(() => {
    setData({
      ...data,
      hideTitle: loading
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading]);

  if (loading) {
    return (
      <DepositLoading
        height="250px"
        text="Submitting your deposit..."
        url="/animation/lottie/money_Tetris_noText.json"
      />
    );
  }

  let errorFormTitle = 'Deposit could not be processed';
  let errorTitle = 'Deposit error';
  let errorDetail = 'Your deposit did not go through due to a processing error.';

  if (depositData?.reason === UNIT_STATUS_REASON.COUNTERPARTY_INSUFFICIENT_FUNDS) {
    errorFormTitle = 'Not enough funds to cover deposit';
    errorTitle = 'Insufficient funds';
    errorDetail =
      "Your deposit did not go through because there weren't enough funds in the account to cover the transaction.";
  }

  if (depositError || depositData?.reason) {
    return (
      <ErrorForm
        errorDetail={errorDetail}
        errorTitle={errorTitle}
        handleClose={handleClose}
        handleClosePreviousModal={handleClosePreviousModal}
        title={errorFormTitle}
      />
    );
  }

  return (
    <SuccessForm
      handleClose={handleClose}
      handleClosePreviousModal={handleClosePreviousModal}
    />
  );
}

ConfirmationForm.propTypes = {
  handleClose: PropTypes.func.isRequired,
  handleClosePreviousModal: PropTypes.func.isRequired
};
